import React, { useEffect, useState } from 'react';
import ProxyPicker from './ProxyPicker';
import { Grid } from '../../ecosystem';
const ProxySelection = (props) => {

    return <Grid fluid className= "body-content body-content--no-top-offset proxy-picker-container">
        <ProxyPicker />
    </Grid>;
}

export default ProxySelection;

/*
    const {    
             isMobile, 
         switchToMyChartUser,   toUrl, savePreferenceCall } = props; 




         myProxies: pl,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        failure: state.memberships.proxyListFailure,
        serverData: state.session.serverData,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        
        history: state.session.history,
        hasMychart: !state.common.epicEHRDown && state.domain.hm,
        proxyListLoaded: state.memberships.proxyListLoaded,
        showDependentProxyForm: state.session.showDependentProxyForm,
        age: state.domain.age,
        showCOVID19Modal: state.session.serverData && state.session.serverData.showCOVID19Modal ? state.session.serverData.showCOVID19Modal : false,
        userName: state.domain.un 
 */